import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import useApi from '../../../CustomHooks/useApi';


export default function PGDashboard() {
    const [formData, setFormData] = useState({
        mobileNumber: '',
        name: '',
        email: '',
        aadharNumber: '',
        consent: false,
        amount: '',
        remark: '',
        paymentMethod: ''
    });

    const [images, setImages] = useState({
        frontAadharImage: null,
        backAadharImage: null,
        customerWithAadharImage: null,
        retrievedAadharImage: null
    });

    const [errors, setErrors] = useState({});
    // const [showInitialNotice, setShowInitialNotice] = useState(true);
    const [showInitialNotice, setShowInitialNotice] = useState(false);
const [showSettlementModal, setShowSettlementModal] = useState(true);
const [settlementMode, setSettlementMode] = useState('');
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showFraudWarningModal, setShowFraudWarningModal] = useState(false);
    const [otpValues, setOtpValues] = useState(['', '', '', '']);
    const [otpResendTimer, setOtpResendTimer] = useState(60);
    const [otpVerified, setOtpVerified] = useState(false);
    const otpInputRefs = useRef([]);
    const timerRef = useRef(null);
    const [showPaymentOptionsModal, setShowPaymentOptionsModal] = useState(false);
    const employeedetails = useSelector((state) => state.auth.employeeDetails);
    const token = useSelector((state) => state.auth.employeeDetails?.token);
    const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
    const username = useSelector((state) => state.auth.employeeDetails?.username);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [customerApiResponse, setCustomerApiResponse] = useState(null);
    const [showResponsePopup, setShowResponsePopup] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [feeData, setFeeData] = useState(null);
    const [showFeePopup, setShowFeePopup] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: '', type: 'success' });
    const [fetchmobile, setFetchmobile] = useState(false);
    const [fetchdata, setFetchdata] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [errorResponse, setErrorResponse] = useState(null);

    


    const { callApi: handlesubmit } = useApi("/pg/add/customer", "POST");
    const { callApi: mobilefetchdata } = useApi("/pg/fetch/details", "GET");
    const { callApi: feecalculate } = useApi("/dmt/fee/calculate/pg", "POST");
    const { callApi: pginitiate } = useApi("/pg/initiate", "POST");

    useEffect(() => {
        if (employeedetails) {
            localStorage.setItem("employeeDetails", JSON.stringify(employeedetails));
        }
    }, [employeedetails]);

    useEffect(() => {
        if (showOtpModal && otpResendTimer > 0) {
            timerRef.current = setInterval(() => {
                setOtpResendTimer(prev => prev - 1);
            }, 1000);
        } else if (otpResendTimer === 0) {
            clearInterval(timerRef.current);
        }

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [showOtpModal, otpResendTimer]);

    const showNotification = (message, type = 'success', duration = 3000) => {
        setNotification({ show: true, message, type });

        setTimeout(() => {
            setNotification({ show: false, message: '', type: 'success' });
        }, duration);
    };



    const handleSettlementSelection = (mode) => {
    setSettlementMode(mode);
    setShowSettlementModal(false);
    setShowInitialNotice(true);
};


    const handleSearchCustomer = async () => {
        if (!formData.mobileNumber || !/^[0-9]{10}$/.test(formData.mobileNumber)) {
            setErrors({
                ...errors,
                mobileNumber: 'Please enter a valid 10-digit mobile number'
            });
            return;
        }

        setErrors({
            ...errors,
            mobileNumber: ''
        });

        setIsSearching(true);

        try {
            // const headers = {
            //     'Authorization': `Bearer ${token}`
            // };
            // console.log("Using token:", token ? "Token exists" : "Token is missing");

            // const response = await fetch(`https://app.indus-tech.co.in/api/pg/fetch/details?remitter_mobile=${formData.mobileNumber}`, {
            //     method: 'GET',
            //     headers: headers
            // });

            // console.log("API response status:", response.status);

            // const data = await response.json();
            const data = await mobilefetchdata(null, `?remitter_mobile=${formData.mobileNumber}`);
            console.log("Customer details response:", data);

            if (data.error_code || data.error || data.message) {
                setImages({
                    frontAadharImage: null,
                    backAadharImage: null,
                    customerWithAadharImage: null,
                    retrievedAadharImage: null
                });
                showNotification(data.message || "Failed to fetch customer details", "error");
                setFetchmobile(true);
                return;
            }

            if (data && data.adhaar) {
                setFormData({
                    ...formData,
                    name: data.full_name || '',
                    email: data.email || '',
                    aadharNumber: data.adhaar || ''
                });

                const fileUrlsMap = {
                    frontAadharUrl: null,
                    backAadharUrl: null,
                    customerWithAadharUrl: null
                };

                if (data.file && Array.isArray(data.file) && data.file.length > 0) {
                    console.log("Aadhar images found:", data.file);

                    data.file.forEach((imageUrl) => {
                        if (imageUrl.includes('/front_aadhar')) {
                            fileUrlsMap.frontAadharUrl = imageUrl;
                        } else if (imageUrl.includes('/back_aadhar')) {
                            fileUrlsMap.backAadharUrl = imageUrl;
                        } else if (imageUrl.includes('/customer_with_aadhar')) {
                            fileUrlsMap.customerWithAadharUrl = imageUrl;
                        }
                    });
                } else {
                    console.log("No image URLs found in response");
                }

                setImages({
                    frontAadharImage: fileUrlsMap.frontAadharUrl,
                    backAadharImage: fileUrlsMap.backAadharUrl,
                    customerWithAadharImage: fileUrlsMap.customerWithAadharUrl,
                    retrievedAadharImage: data.file && data.file.length > 0 ? data.file[0] : null
                });
                showNotification("Customer details fetched successfully!", "success");
                setFetchmobile(true);
                setFetchdata(true);
            } else {
                showNotification("Customer not found or there was an issue retrieving details.", "error");
                setImages({
                    frontAadharImage: null,
                    backAadharImage: null,
                    customerWithAadharImage: null,
                    retrievedAadharImage: null
                });
            }
        } catch (error) {
            console.error("Error fetching customer details:", error);
            showNotification(`Failed to fetch customer details: ${error.message}`, "error");
        } finally {
            setIsSearching(false);
        }
    };

    const validateField = (name, value) => {
        let error = '';

        switch (name) {
            case 'mobileNumber':
                if (!value) {
                    error = 'Mobile number is required';
                } else if (!/^[0-9]{10}$/.test(value)) {
                    error = 'Mobile number must be 10 digits';
                }
                break;
            case 'name':
                if (!value) {
                    error = 'Name is required';
                } else if (value.length < 3) {
                    error = 'Name must be at least 3 characters';
                }
                break;
            case 'email':
                if (!value) {
                    error = 'Email is required';
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    error = 'Invalid email format';
                }
                break;
            case 'aadharNumber':
                if (!value) {
                    error = 'Aadhar number is required';
                } else if (!/^[0-9]{12}$/.test(value)) {
                    error = 'Aadhar number must be 12 digits';
                }
                break;
            case 'frontAadharImage':
                if (!value && !images.retrievedAadharImage) {
                    error = 'Front Aadhar image is required';
                }
                break;
            case 'backAadharImage':
                break;
            case 'customerWithAadharImage':
                if (!value) {
                    error = 'Customer with Aadhar image is required';
                }
                break;
            case 'consent':
                if (!value) {
                    error = 'You must agree to the consent';
                }
                break;
            case 'amount':
                if (!value) {
                    error = 'Amount is required';
                } else if (isNaN(value) || parseFloat(value) <= 0) {
                    error = 'Amount must be a positive number';
                }
                break;
            case 'remark':
                if (!value) {
                    error = 'Remark is required';
                }
                break;
            case 'paymentMethod':
                if (!value) {
                    error = 'Please select a payment method';
                }
                break;
            default:
                break;
        }

        return error;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newValue;

        if (type === 'checkbox') {
            newValue = checked;
        } else {
            newValue = value;
        }

        if (name === "amount") {
            if (!/^\d*$/.test(newValue)) return; // only numbers
            if (parseInt(newValue) > 100000) return; // max limit
        }

        let updatedFormData = {
            ...formData,
            [name]: newValue
        };

        if (name === 'mobileNumber') {
            setFetchmobile(false);
            setFetchdata(false);
            updatedFormData = {
                ...updatedFormData,
                name: "",
                email: "",
                aadharNumber: ""
            };
        }

        setFormData(updatedFormData);

        const error = validateField(name, newValue);
        setErrors({
            ...errors,
            [name]: error
        });
    };

    const handleImageChange = (e) => {
        const { name, files } = e.target;
        const file = files[0] || null;

        setImages({
            ...images,
            [name]: file
        });

        const error = validateField(name, file);
        setErrors({
            ...errors,
            [name]: error
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submit triggered");

        let newErrors = {};
        let isValid = true;

        Object.keys(formData).forEach(key => {
            if (key !== 'amount' && key !== 'remark' && key !== 'paymentMethod') {
                const error = validateField(key, formData[key]);
                if (error) {
                    newErrors[key] = error;
                    isValid = false;
                }
            }
        });

        const requiredImageUploads = [];

        if (!images.frontAadharImage || typeof images.frontAadharImage !== 'string') {
            requiredImageUploads.push('frontAadharImage');
        }

        if (!images.customerWithAadharImage) {
            requiredImageUploads.push('customerWithAadharImage');
        }

        requiredImageUploads.forEach(key => {
            const error = validateField(key, images[key]);
            if (error) {
                newErrors[key] = error;
                isValid = false;
            }
        });

        setErrors(newErrors);

        if (isValid) {
            console.log("Form validated, proceeding to add customer");
            setIsLoading(true);
            try {
                const apiFormData = new FormData();

                apiFormData.append('remitterMobile', formData.mobileNumber);
                apiFormData.append('fullName', formData.name);
                apiFormData.append('email', formData.email);
                apiFormData.append('adhaar', formData.aadharNumber);
                apiFormData.append('address', "Default Address");
                apiFormData.append('mid', username);

                if (images.frontAadharImage) {
                    if (images.frontAadharImage instanceof File) {
                        apiFormData.append('file[front_aadhar]', images.frontAadharImage);
                    }
                }

                if (images.backAadharImage) {
                    if (images.backAadharImage instanceof File) {
                        apiFormData.append('file[back_aadhar]', images.backAadharImage);
                    }
                }

                if (images.customerWithAadharImage) {
                    if (images.customerWithAadharImage instanceof File) {
                        apiFormData.append('file[customer_with_aadhar]', images.customerWithAadharImage);
                    }
                }

                for (let pair of apiFormData.entries()) {
                    console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
                }

                // const headers = {
                //     'Authorization': `Bearer ${token}`,
                // };

                console.log("apiformdataa", apiFormData);
                // const response = await fetch('https://app.indus-tech.co.in/api/pg/add/customer', {
                //     method: 'POST',
                //     headers: headers,
                //     body: apiFormData
                // });

                // if (!response.ok) {
                //     throw new Error(`API call failed with status: ${response.status}`);
                // }

                // const data = await response.json();
                const data = await handlesubmit(apiFormData);
                console.log("Add customer API response:", data);

                setCustomerApiResponse(data);
                setShowResponsePopup(true);
            } catch (error) {
                console.error("Error adding customer:", error);
                showNotification("An error occurred while adding the customer. Please try again.", "error");
            } finally {
                setIsLoading(false)
            }
        } else {
            const firstErrorField = document.querySelector('.error-message');
            if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    };

    const resetForm = () => {
        setFormData({
            mobileNumber: '',
            name: '',
            email: '',
            aadharNumber: '',
            consent: false,
            amount: '',
            remark: '',
            paymentMethod: ''
        });

        setImages({
            frontAadharImage: null,
            backAadharImage: null,
            customerWithAadharImage: null,
            retrievedAadharImage: null
        });

        setErrors({});
        setOtpVerified(false);
        setRedirectUrl(null);
    };

    const handleResponsePopupClose = () => {
        setShowResponsePopup(false);
        setShowOtpModal(true);
        setOtpVerified(false);
        setOtpValues(['', '', '', '']);
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0] || null;

        setFormData({
            ...formData,
            [name]: file
        });

        const error = validateField(name, file);
        setErrors({
            ...errors,
            [name]: error
        });
    };

    const handleOtpChange = (index, value) => {
        if (otpVerified) return;

        if (value.length > 1) {
            value = value.slice(0, 1);
        }

        if (!/^\d*$/.test(value) && value !== '') {
            return;
        }

        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);

        if (value !== '' && index < otpValues.length - 1) {
            otpInputRefs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (e, index) => {
        if (otpVerified) return;

        if (e.key === 'Backspace') {
            if (otpValues[index] === '' && index > 0) {
                otpInputRefs.current[index - 1].focus();
            }
        }
    };

    const handleResendOtp = () => {
        setOtpResendTimer(60);
        setOtpValues(['', '', '', '']);
        setOtpVerified(false);
        console.log("Resending OTP");
    };

    const validateOtp = () => {
        return !otpValues.some(val => val === '');
    };

    const handleVerifyOtp = () => {
        if (validateOtp()) {
            const otp = otpValues.join('');
            console.log("OTP Verified:", otp);
            setOtpVerified(true);

            setErrors({
                ...errors,
                otp: ''
            });
        } else {
            setErrors({
                ...errors,
                otp: 'All OTP digits are required'
            });
        }
    };

    const validateOtpForm = () => {
        let isValid = true;
        let newErrors = { ...errors };

        if (!formData.amount) {
            newErrors.amount = 'Amount is required';
            isValid = false;
        } else if (isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
            newErrors.amount = 'Amount must be a positive number';
            isValid = false;
        } else {
            delete newErrors.amount;
        }

        if (!formData.remark) {
            newErrors.remark = 'Remark is required';
            isValid = false;
        } else {
            delete newErrors.remark;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleAmountRemarkSubmit = () => {
        if (validateOtpForm()) {
            console.log("Amount:", formData.amount);
            console.log("Remark:", formData.remark);

            setShowOtpModal(false);
            // setShowFraudWarningModal(true);
            setShowPaymentOptionsModal(true);
        }
    };

    const handlePaymentMethodSelect = (method) => {
        setFormData({
            ...formData,
            paymentMethod: method
        });

        const error = validateField('paymentMethod', method);
        setErrors({
            ...errors,
            paymentMethod: error
        });
    };

    const handlePaymentOptionsContinue = async () => {
        if (!formData.paymentMethod) {
            setErrors({
                ...errors,
                paymentMethod: 'Please select a payment method'
            });
            return;
        }

        console.log("Selected payment method:", formData.paymentMethod);

        try {
            let cardType = '';
            if (formData.paymentMethod === 'credit_card') {
                cardType = 'CREDIT';
            }
            console.log("Using card_type:", cardType);

            const feePayload = {
                provider: "PG",
                sub_provider: "SHADVL",
                amount: parseFloat(formData.amount || 0),
                commercial_type: "TRANSACTION_FEE"
            };

            // const headers = {
            //     'Authorization': `Bearer ${token}`,
            //     'Content-Type': 'application/json'
            // };

            // const encodedCardType = encodeURIComponent(cardType);

            // console.log("Encoded card_type:", encodedCardType);
            // console.log(`API URL: https://app.indus-tech.co.in/dmt/fee/calculate/pg?card_type=${cardType}`);

            // const feeResponse = await fetch(`https://app.indus-tech.co.in/dmt/fee/calculate/pg?card_type=${cardType}`, {
            //     method: 'POST',
            //     headers: headers,
            //     body: JSON.stringify(feePayload)
            // });

            // if (!feeResponse.ok) {
            //     throw new Error(`Fee calculation API call failed with status: ${feeResponse.status}`);
            // }

            const feeData = await feecalculate(feePayload, `?card_type=${cardType}`);
            console.log("Fee calculation response:", feeData);

            setFeeData(feeData);
            setShowFeePopup(true);

        } catch (error) {
            console.error("Error during payment process:", error);
            showNotification("An error occurred during the payment process. Please try again.", "error");
        }
    };
    // const handleFeeConfirmation = async () => {
    //     setLoading(true);
    //     try {
    //         let initiateCardType = '';
    //         if (formData.paymentMethod === 'upi') {
    //             initiateCardType = 'UPI';
    //         } else if (formData.paymentMethod === 'debit_card') {
    //             initiateCardType = 'DEBIT';
    //         } else if (formData.paymentMethod === 'credit_card') {
    //             initiateCardType = 'CREDIT';
    //         } else if (formData.paymentMethod === "NETBANKING") {
    //             initiateCardType = 'NETBANKING';
    //         }

    //         console.log("Using initiateCardType:", initiateCardType);

    //         const initiatePayload = {
    //             txn_amount: feeData.txn_amount,
    //             net_amount: feeData.net_amount,
    //             mid: username,
    //             merchant_account_no: account_no,
    //             full_name: formData.name,
    //             description: formData.remark,
    //             email: formData.email,
    //             remitter_mobile: formData.mobileNumber,
    //             card_type: initiateCardType
    //         };

    //         console.log("Initiate payment payload:", initiatePayload);

    //         // const headers = {
    //         //     'Authorization': `Bearer ${token}`,
    //         //     'Content-Type': 'application/json'
    //         // };

    //         // const initiateResponse = await fetch('https://app.indus-tech.co.in/api/pg/initiate', {
    //         //     method: 'POST',
    //         //     headers: headers,
    //         //     body: JSON.stringify(initiatePayload)
    //         // });

    //         // if (!initiateResponse.ok) {
    //         //     throw new Error(`Initiate payment API call failed with status: ${initiateResponse.status}`);
    //         // }

    //         // const initiateData = await initiateResponse.json();
    //         const initiateData = await pginitiate(initiatePayload);
    //         console.log("Initiate payment response:", initiateData);
    //         if (initiateData && initiateData.redirectUrl) {
    //             setRedirectUrl(initiateData.redirectUrl);
    //         }
    //         setShowFeePopup(false);
    //         setShowPaymentOptionsModal(false);
    //         setShowFraudWarningModal(true);
    //     } catch (error) {
    //         console.error("Error during payment initiation:", error);
    //         showNotification("An error occurred during the payment initiation. Please try again.", "error");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    const handleFeeConfirmation = async () => {
        setLoading(true);
        try {
            let initiateCardType = '';
            if (formData.paymentMethod === 'credit_card') {
                initiateCardType = 'CREDIT';
            }

            console.log("Using initiateCardType:", initiateCardType);

            const initiatePayload = {
                txn_amount: feeData.txn_amount,
                net_amount: feeData.net_amount,
                mid: username,
                merchant_account_no: account_no,
                full_name: formData.name,
                description: formData.remark,
                email: formData.email,
                remitter_mobile: formData.mobileNumber,
                card_type: initiateCardType,
                settlement_mode: settlementMode
            };

            console.log("Initiate payment payload:", initiatePayload);

            const initiateData = await pginitiate(initiatePayload);
            console.log("Initiate payment response:", initiateData);

            // Check if response contains error
            if (initiateData.error_code && initiateData.error_code !== 200) {
                // Handle error response
                setErrorResponse(initiateData);
                setShowErrorPopup(true);
                setShowFeePopup(false);
                setShowPaymentOptionsModal(false);
                return;
            }

            // Success case - existing logic
            if (initiateData && initiateData.link) {
                setRedirectUrl(initiateData.link);
            }
            setShowFeePopup(false);
            setShowPaymentOptionsModal(false);
            setShowFraudWarningModal(true);

        } catch (error) {
            console.error("Error during payment initiation:", error);
            showNotification("An error occurred during the payment initiation. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleErrorPopupClose = () => {
        setShowErrorPopup(false);
        setErrorResponse(null);
        // Optionally reset form or navigate back to previous step
        resetForm();
    };

    const handleFeeCancellation = () => {
        setShowFeePopup(false);
        setFeeData(null);
    };
    const closePaymentOptionsModal = () => {
        setShowPaymentOptionsModal(false);
    };

    const closeOtpModal = () => {
        setShowOtpModal(false);
        setOtpValues(['', '', '', '']);
        setOtpResendTimer(60);
        setOtpVerified(false);
    };

    const handleAgree = () => {
        setShowFraudWarningModal(false);
        console.log("User agreed to fraud warning");

        if (redirectUrl) {
            window.open(redirectUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        resetForm();
    };

    const handleDisagree = () => {
        setShowFraudWarningModal(false);
        console.log("User disagreed with fraud warning");
    };

    const handleInitialNoticeOkay = () => {
        setShowInitialNotice(false);
    };

    const handleDownloadConsentForm = () => {
        const pdfUrl = '/documents/consentform.pdf';

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'Cardholder_Consent_Form.pdf';
        link.target = '_blank';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    if (showSettlementModal) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 relative p-8">
                    <h2 className="text-2xl font-bold mb-4 text-center">Select Settlement Mode</h2>
                    <p className="text-gray-600 mb-6 text-center">Please choose your preferred settlement cycle and review the applicable charges.</p>
                    
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        {/* T-0 Option Card */}
                        <div className="border border-blue-200 bg-blue-50 rounded-lg p-4 w-full flex flex-col">
                            <h3 className="font-bold text-lg mb-2 text-blue-800 text-center">T-0 (Same Day)</h3>
                            <div className="text-sm text-gray-700 mb-5 space-y-2">
                                <div className="flex justify-between">
                                    <span>Visa/Master:</span>
                                    <span className="font-medium">1.80% + GST</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Rupay:</span>
                                    <span className="font-medium">2.4% + GST</span>
                                </div>
                            </div>
                            <button
                                onClick={() => handleSettlementSelection('T0')}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium w-full transition-colors mt-auto"
                            >
                                Select T-0
                            </button>
                        </div>

                        {/* T-1 Option Card */}
                        <div className="border border-orange-200 bg-orange-50 rounded-lg p-4 w-full flex flex-col">
                            <h3 className="font-bold text-lg mb-2 text-orange-800 text-center">T-1 (Next Day)</h3>
                            <div className="text-sm text-gray-700 mb-5 space-y-2">
                                <div className="flex justify-between">
                                    <span>Base Rate:</span>
                                    <span className="font-medium">1.65% + GST</span>
                                </div>
                                <div className="flex justify-between text-orange-800 bg-orange-100 px-2 py-1 rounded">
                                    <span>Total Net:</span>
                                    <span className="font-bold">1.95%</span>
                                </div>
                            </div>
                            <button
                                onClick={() => handleSettlementSelection('T1')}
                                className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md font-medium w-full transition-colors mt-auto"
                            >
                                Select T-1
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    if (showInitialNotice) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
                    <div className="p-8">
                        <h2 className="text-2xl font-bold text-center text-red-500 mb-6">Important Notice/Advisory</h2>

                        <div className="mb-6">
                            <ol className="list-decimal pl-8 space-y-4">
                                <li>Merchant is advised to collect the Mobile Number, Email ID, Proof (PAN Card) And Address Proof Of the Customer to use Payment Gateway service.;</li>
                                <li>Maintain a Register/ Ledger for every transaction of Payment Gateway in details.</li>
                                <li>For all transaction, merchant are the sole responsible person. ShreeBalaJee Connect PVT.LTD. (bingopay) are not responsible for any Fraudulent /Mis-use/ Chargeback of card Transactions done by you.</li>
                            </ol>
                        </div>

                        <div className="flex justify-center">
                            <button
                                onClick={handleInitialNoticeOkay}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-3 rounded-md font-medium w-1/3"
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white p-6 rounded-xl border border-gray-200 mx-auto">
            <div className="text-center mb-4">
                <h1 className="text-2xl font-bold">Add Money</h1>
            </div>

            <div className="flex justify-center mb-8">
                <div className="inline-flex items-center space-x-2 text-orange-500 bg-orange-100 rounded-md px-3 py-2">
                    <span className="rounded-full">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_2928_21237)">
                                <mask id="mask0_2928_21237" maskUnits="userSpaceOnUse" x="-1" y="0" width="21" height="21">
                                    <path d="M-0.00012207 0.00781441H19.9999V20.0078H-0.00012207V0.00781441Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_2928_21237)">
                                    <path d="M3.33169 16.6369C5.16227 18.4675 7.58106 19.412 9.99989 19.4218C12.4187 19.4316 14.8375 18.5065 16.6681 16.6759C18.6039 14.7401 19.5161 12.1293 19.4048 9.59414L17.0205 9.1968C17.2577 11.2569 16.5878 13.4026 15.0108 14.9796C13.6038 16.3865 11.7808 17.1045 9.96083 17.0943C8.16684 17.0843 6.37575 16.3664 4.98895 14.9796L6.23192 13.7366L1.26009 12.908L2.08872 17.8798L3.33169 16.6369Z" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                    <path d="M16.6681 3.38023C14.8375 1.54965 12.4187 0.605079 9.99989 0.595313C7.5811 0.585547 5.16227 1.51059 3.33169 3.34117C1.39591 5.27695 0.483601 7.88777 0.59489 10.423L2.97927 10.8203C2.74212 8.76016 3.41204 6.61445 4.98903 5.03746C6.38583 3.64063 8.19286 2.92266 9.99989 2.92266C11.8069 2.92266 13.614 3.64063 15.0108 5.0375L13.7679 6.28047L18.7397 7.10906L17.9111 2.13727L16.6681 3.38023Z" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                    <path d="M9.99992 5.90625V7.66406" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                    <path d="M9.99992 12.3516V14.1094" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                    <path d="M9.99992 10.0078C9.35273 10.0078 8.82804 9.48313 8.82804 8.83594C8.82804 8.18875 9.35273 7.66406 9.99992 7.66406C10.6471 7.66406 11.1718 8.18875 11.1718 8.83594" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                    <path d="M9.99992 10.0078C10.6471 10.0078 11.1718 10.5325 11.1718 11.1797C11.1718 11.8269 10.6471 12.3516 9.99992 12.3516C9.35273 12.3516 8.82804 11.8269 8.82804 11.1797" stroke="#D45A23" strokeWidth="1.17187" strokeMiterlimit="10" />
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_2928_21237">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                    <span>We spotted a PG — now we're giving it back, like financial karma.</span>
                </div>
            </div>

            <form onSubmit={handleSubmit} noValidate>
                <div className="mb-8">
                    <h2 className="text-lg font-medium mb-4">Customer Details:-</h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="relative">
                            <label className="block text-gray-700 mb-1 text-sm">Customer Mobile Number*</label>
                            <div className="flex">
                                <input
                                    type="text"
                                    name="mobileNumber"
                                    value={formData.mobileNumber}
                                    onChange={handleChange}
                                    placeholder="Enter Mobile number"
                                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 pr-20 ${errors.mobileNumber ? 'border-red-500' : ''}`}
                                />
                                <button
                                    type="button"
                                    onClick={handleSearchCustomer}
                                    disabled={isSearching}
                                    className={`absolute right-1 ${isSearching ? 'bg-gray-400' : 'bg-orange-500 hover:bg-orange-600'} text-white px-3 py-1 rounded text-sm`}
                                    style={{ top: "29px", height: "30px" }}
                                >
                                    {isSearching ? 'Searching...' : 'Search'}
                                </button>
                            </div>
                            {errors.mobileNumber && <p className="text-red-500 text-xs mt-1 error-message">{errors.mobileNumber}</p>}
                        </div>
                        {fetchmobile && (
                            <>
                                <div>
                                    <label className="block text-gray-700 mb-1 text-sm">Customer Full Name*</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        disabled={fetchdata}
                                        placeholder="Enter Customer Name"
                                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 ${errors.name ? 'border-red-500' : ''}`}
                                    />
                                    {errors.name && <p className="text-red-500 text-xs mt-1 error-message">{errors.name}</p>}
                                </div>

                                <div>
                                    <label className="block text-gray-700 mb-1 text-sm">Customer Email ID*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        disabled={fetchdata}
                                        placeholder="Enter Customer Email"
                                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 ${errors.email ? 'border-red-500' : ''}`}
                                    />
                                    {errors.email && <p className="text-red-500 text-xs mt-1 error-message">{errors.email}</p>}
                                </div>
                            </>
                        )}

                    </div>
                </div>
                {fetchmobile && (<>

                    <div className="mb-8">
                        <h2 className="text-lg font-medium mb-4">Aadhar Details:-</h2>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                            <div>
                                <label className="block text-gray-700 mb-1 text-sm">Customer Aadhar Number*</label>
                                <input
                                    type="text"
                                    name="aadharNumber"
                                    value={formData.aadharNumber}
                                    disabled={fetchdata}
                                    onChange={handleChange}
                                    placeholder="Enter Customer Aadhar number"
                                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 ${errors.aadharNumber ? 'border-red-500' : ''}`}
                                />
                                {errors.aadharNumber && <p className="text-red-500 text-xs mt-1 error-message">{errors.aadharNumber}</p>}
                            </div>
                            <div>
                                <label className="block text-gray-700 mb-1 text-sm">Front Aadhar Image*</label>
                                <div className={`flex items-center space-x-2 border rounded-md p-2 ${errors.frontAadharImage ? 'border-red-500' : ''}`}>
                                    <input
                                        type="file"
                                        name="frontAadharImage"
                                        id="frontAadharImage"
                                        onChange={handleImageChange}
                                        className="hidden"
                                        accept="image/*"
                                        disabled={typeof images.frontAadharImage === 'string'}
                                    />
                                    <label
                                        htmlFor="frontAadharImage"
                                        className={`${typeof images.frontAadharImage === 'string'
                                            ? 'bg-gray-300 cursor-not-allowed'
                                            : 'bg-gray-200 cursor-pointer hover:bg-gray-300'} 
                text-gray-700 px-2 py-1 text-sm rounded`}
                                    >
                                        Choose File
                                    </label>
                                    <span className="text-sm text-gray-500">
                                        {images.frontAadharImage
                                            ? (typeof images.frontAadharImage === 'string'
                                                ? 'Image already uploaded'
                                                : images.frontAadharImage.name)
                                            : 'No File Chosen'}
                                    </span>
                                </div>
                                {errors.frontAadharImage && <p className="text-red-500 text-xs mt-1 error-message">{errors.frontAadharImage}</p>}
                            </div>
                            <div>
                                <label className="block text-gray-700 mb-1 text-sm">Back Aadhar Image*</label>
                                <div className={`flex items-center space-x-2 border rounded-md p-2 ${errors.backAadharImage ? 'border-red-500' : ''}`}>
                                    <input
                                        type="file"
                                        name="backAadharImage"
                                        id="backAadharImage"
                                        onChange={handleImageChange}
                                        className="hidden"
                                        accept="image/*"
                                        disabled={typeof images.backAadharImage === 'string'}
                                    />
                                    <label
                                        htmlFor="backAadharImage"
                                        className={`${typeof images.backAadharImage === 'string'
                                            ? 'bg-gray-300 cursor-not-allowed'
                                            : 'bg-gray-200 cursor-pointer hover:bg-gray-300'} 
                text-gray-700 px-2 py-1 text-sm rounded`}
                                    >
                                        Choose File
                                    </label>
                                    <span className="text-sm text-gray-500">
                                        {images.backAadharImage
                                            ? (typeof images.backAadharImage === 'string'
                                                ? 'Image already uploaded'
                                                : images.backAadharImage.name)
                                            : 'No File Chosen'}
                                    </span>
                                </div>
                                {errors.backAadharImage && <p className="text-red-500 text-xs mt-1 error-message">{errors.backAadharImage}</p>}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                            <div>
                                <label className="block text-gray-700 mb-1 text-sm">Customer With Aadhar Number Card*</label>
                                <div className={`flex items-center space-x-2 border rounded-md p-2 max-w-xs ${errors.customerWithAadharImage ? 'border-red-500' : ''}`}>
                                    <input
                                        type="file"
                                        name="customerWithAadharImage"
                                        id="customerWithAadharImage"
                                        onChange={handleImageChange}
                                        className="hidden"
                                        accept="image/*"
                                        disabled={typeof images.customerWithAadharImage === 'string'}
                                    />
                                    <label
                                        htmlFor="customerWithAadharImage"
                                        className={`${typeof images.customerWithAadharImage === 'string'
                                            ? 'bg-gray-300 cursor-not-allowed'
                                            : 'bg-gray-200 cursor-pointer hover:bg-gray-300'} 
                text-gray-700 px-2 py-1 text-sm rounded`}
                                    >
                                        Choose File
                                    </label>
                                    <span className="text-sm text-gray-500">
                                        {images.customerWithAadharImage
                                            ? (typeof images.customerWithAadharImage === 'string'
                                                ? 'Image already uploaded'
                                                : images.customerWithAadharImage.name)
                                            : 'No File Chosen'}
                                    </span>
                                </div>
                                {errors.customerWithAadharImage && <p className="text-red-500 text-xs mt-1 error-message">{errors.customerWithAadharImage}</p>}
                            </div>
                        </div>
                    </div>

                    {(images.frontAadharImage || images.backAadharImage || images.customerWithAadharImage) && (
                        <div className="mb-4">
                            <h3 className="text-sm font-medium text-gray-700 mb-2">Retrieved Aadhar Images:</h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                {images.frontAadharImage && (
                                    <div className="border border-gray-200 rounded p-2">
                                        <h4 className="text-xs font-medium text-gray-600 mb-1">Front Aadhar</h4>
                                        {/* <img
                                            src={images.frontAadharImage}
                                            alt="Front Aadhar"
                                            className="h-32 object-contain mx-auto"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                const errMsg = document.createElement('p');
                                                // errMsg.textContent = 'Unable to load image';
                                                errMsg.className = 'text-xs text-red-500 text-center';
                                                e.target.parentNode.appendChild(errMsg);
                                            }}
                                        /> */}
                                        <img
                                            src={
                                                typeof images.frontAadharImage === "string"
                                                    ? images.frontAadharImage
                                                    : URL.createObjectURL(images.frontAadharImage)
                                            }
                                            alt="Front Aadhar"
                                            className="h-32 object-contain mx-auto"
                                        />
                                    </div>
                                )}

                                {images.backAadharImage && (
                                    <div className="border border-gray-200 rounded p-2">
                                        <h4 className="text-xs font-medium text-gray-600 mb-1">Back Aadhar</h4>
                                        {/* <img
                                            src={images.backAadharImage}
                                            alt="Back Aadhar"
                                            className="h-32 object-contain mx-auto"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                const errMsg = document.createElement('p');
                                                // errMsg.textContent = 'Unable to load image';
                                                errMsg.className = 'text-xs text-red-500 text-center';
                                                e.target.parentNode.appendChild(errMsg);
                                            }}
                                        /> */}
                                        <img
                                            src={
                                                typeof images.backAadharImage === "string"
                                                    ? images.backAadharImage
                                                    : URL.createObjectURL(images.backAadharImage)
                                            }
                                            alt="Back Aadhar"
                                            className="h-32 object-contain mx-auto"
                                        />
                                    </div>
                                )}

                                {images.customerWithAadharImage && (
                                    <div className="border border-gray-200 rounded p-2">
                                        <h4 className="text-xs font-medium text-gray-600 mb-1">Customer with Aadhar</h4>
                                        {/* <img
                                            src={images.customerWithAadharImage}
                                            alt="Customer with Aadhar"
                                            className="h-32 object-contain mx-auto"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                const errMsg = document.createElement('p');
                                                // errMsg.textContent = 'Unable to load image';
                                                errMsg.className = 'text-xs text-red-500 text-center';
                                                e.target.parentNode.appendChild(errMsg);
                                            }}
                                        /> */}
                                        <img
                                            src={
                                                typeof images.customerWithAadharImage === "string"
                                                    ? images.customerWithAadharImage
                                                    : URL.createObjectURL(images.customerWithAadharImage)
                                            }
                                            alt="Customer with Aadhar"
                                            className="h-32 object-contain mx-auto"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="mb-8">
                        <h2 className="text-lg font-medium mb-4">Consent Details:-</h2>

                        <div className="mb-4 flex items-center space-x-2">
                            <button
                                type="button"
                                onClick={handleDownloadConsentForm}
                                className="bg-blue-500 text-white p-1 rounded hover:bg-blue-600 transition-colors"
                                title="Download Card Holder Consent Form"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                </svg>
                            </button>
                            <span className="font-medium cursor-pointer hover:text-blue-600" onClick={handleDownloadConsentForm}>Card Holder Consent Form</span>
                        </div>

                        <div className={`flex items-start space-x-2 mb-2 ${errors.consent ? 'pb-1' : 'mb-8'}`}>
                            <input
                                type="checkbox"
                                name="consent"
                                id="consent"
                                checked={formData.consent}
                                onChange={handleChange}
                                className={`mt-1 ${errors.consent ? 'border-red-500' : ''}`}
                            />
                            <label htmlFor="consent" className="text-sm text-gray-700">
                                I as ShreeBalaJee Connect PVT. LTD. (BINGOPAY) Merchant, confirm that I have downloaded and filled the form on behalf of the customer. At any given point of time when I am asked to provide details regarding this transaction, I will provide.
                            </label>
                        </div>
                        {errors.consent && <p className="text-red-500 text-xs mb-6 error-message">{errors.consent}</p>}

                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`w-full py-3 rounded-md text-white transition 
    ${isLoading ? 'bg-orange-300 cursor-not-allowed opacity-70' : 'bg-orange-500 hover:bg-orange-600 cursor-pointer'}`}
                        >
                            {isLoading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>

                </>)}

            </form>

            {showOtpModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 relative">
                        <button
                            onClick={closeOtpModal}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="p-6">
                            {/* <h2 className="text-2xl font-bold text-center mb-2">OTP Verification</h2>
                            <p className="text-gray-500 text-center mb-6">OTP sent to your mobile +{formData.mobileNumber || '917895564235'}</p> */}

                            {/* <div className="flex flex-col items-center justify-center mb-4">
                                <div className="flex items-center justify-center mb-2">
                                    <div className="flex justify-center space-x-2">
                                        {otpValues.map((value, index) => (
                                            <input
                                                key={index}
                                                ref={el => otpInputRefs.current[index] = el}
                                                type="text"
                                                maxLength="1"
                                                value={value}
                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                                disabled={otpVerified}
                                                className={`w-12 h-12 text-center text-xl border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 
                                                ${errors.otp ? 'border-red-500' : 'border-gray-300'}
                                                ${otpVerified ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''}`}
                                            />
                                        ))}
                                    </div>
                                    <div className="ml-4">
                                        <button
                                            onClick={handleVerifyOtp}
                                            type="button"
                                            disabled={otpVerified}
                                            className={`px-6 py-2 rounded-md ${otpVerified
                                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                : 'bg-blue-500 hover:bg-blue-600 text-white'
                                                }`}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                                {errors.otp && <p className="text-red-500 text-xs error-message">{errors.otp}</p>}

                                {otpVerified && (
                                    <div className="text-green-500 text-sm font-medium mt-2 bg-green-50 p-2 rounded-md border border-green-200 w-full text-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        OTP verified successfully! Please fill amount and remark details below.
                                    </div>
                                )}
                            </div>

                            <div className="text-center mb-6">
                                {otpResendTimer > 0 ? (
                                    <p className="text-gray-500">
                                        <span className={`${otpVerified ? 'text-gray-400' : 'text-blue-500'} font-medium`}>Resend OTP</span> in {otpResendTimer} seconds
                                    </p>
                                ) : (
                                    <button
                                        onClick={handleResendOtp}
                                        disabled={otpVerified}
                                        className={`font-medium ${otpVerified ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'}`}
                                    >
                                        Resend OTP
                                    </button>
                                )}
                            </div> */}

                            <div className="max-w-md mx-auto space-y-4 mb-6">
                                <div>
                                    <label className="block text-gray-700 mb-1">
                                        Enter Amount* (Maximum ₹1,00,000 allowed)
                                    </label>
                                    <input
                                        type="text"
                                        name="amount"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        placeholder="Enter Your Amount"
                                        // disabled={!otpVerified}
                                        // className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 
                                        // ${errors.amount ? 'border-red-500' : ''} 
                                        // ${!otpVerified ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500`}
                                    />
                                    {errors.amount && <p className="text-red-500 text-xs mt-1 error-message">{errors.amount}</p>}
                                    {/* <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                                        <p className="text-red-600 font-bold text-xs">Settlement: T+1</p>
                                        <p className="text-red-600 font-bold text-xs mt-1">
                                            Money collected through PG today will be credited to your BingoPay wallet the next business day (from 10 AM onwards).
                                        </p>
                                        <p className="text-red-600 font-bold text-xs mt-1">
                                            Example: A payment received on Monday will reach your wallet on Tuesday.
                                        </p>
                                    </div> */}
                                    <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
    <p className="text-red-600 font-bold text-xs">
        Settlement: {settlementMode === 'T0' ? 'T+0' : 'T+1'}
    </p>
    <p className="text-red-600 font-bold text-xs mt-1">
        {settlementMode === 'T0' 
            ? 'Money collected through PG today will be credited to your BingoPay wallet on the same day.' 
            : 'Money collected through PG today will be credited to your BingoPay wallet the next business day (from 10 AM onwards).'}
    </p>
    {settlementMode === 'T1' && (
        <p className="text-red-600 font-bold text-xs mt-1">
            Example: A payment received on Monday will reach your wallet on Tuesday.
        </p>
    )}
</div>
                                </div>
                                <div>
                                    <label className="block text-gray-700 mb-1">Remark*</label>
                                    <input
                                        type="text"
                                        name="remark"
                                        value={formData.remark}
                                        onChange={handleChange}
                                        placeholder="Enter Your Remark"
                                        // disabled={!otpVerified}
                                        // className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 
                                        // ${errors.remark ? 'border-red-500' : ''} 
                                        // ${!otpVerified ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500`}
                                    />
                                    {errors.remark && <p className="text-red-500 text-xs mt-1 error-message">{errors.remark}</p>}
                                </div>
                            </div>

                            <div className="max-w-md mx-auto">
                                <button
                                    onClick={handleAmountRemarkSubmit}
                                    // disabled={!otpVerified}
                                    // className={`w-full py-3 rounded-md ${otpVerified
                                    //     ? 'bg-green-500 hover:bg-green-600 text-white'
                                    //     : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    //     }`}

                                    className={`w-full py-3 rounded-md bg-green-500 hover:bg-green-600 text-white`}

                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showFraudWarningModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-xl mx-4 relative">
                        <div className="p-8">
                            <h2 className="text-2xl font-bold text-center mb-6">BEWARE OF FRAUDSTERS</h2>

                            <div className="mb-6">
                                <p className="mb-4">Dear Merchant/Distributor,</p>

                                <p className="mb-4">Beware of fraudster while doing PG transaction. Make sure you check the following things before initiating a transaction:-</p>

                                <ol className="list-decimal pl-8 space-y-2">
                                    <li>Check if the Physical credit/debit card is present with the customer.</li>
                                    <li>Ask for original KYC document to ensure that the Name of card matches the KYC.</li>
                                    <li>Ensure that the OTP is received on the Phone available with the customer. Ensure that the transactions done are not fraudulent in nature. If any fraud case is reported, you will be held liable and responsible.</li>
                                </ol>
                            </div>

                            <div className="flex justify-center space-x-4">
                                <button
                                    onClick={handleAgree}
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-3 rounded-md font-medium w-1/2"
                                >
                                    I agree
                                </button>
                                <button
                                    onClick={handleDisagree}
                                    className="border border-blue-500 text-blue-500 hover:bg-blue-50 px-10 py-3 rounded-md font-medium w-1/2"
                                >
                                    Disagree
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showPaymentOptionsModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 relative">
                        <button
                            onClick={closePaymentOptionsModal}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-center mb-6">Select Payment Method</h2>

                            <div className="mb-6 space-y-4">
                                {/* <div
                                    onClick={() => handlePaymentMethodSelect('debit_card')}
                                    className={`border rounded-lg p-4 cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50 ${formData.paymentMethod === 'debit_card' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                                >
                                    <div className="flex items-center space-x-3">
                                        <div className={`w-6 h-6 flex-shrink-0 rounded-full border ${formData.paymentMethod === 'debit_card' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center`}>
                                            {formData.paymentMethod === 'debit_card' && (
                                                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                                            )}
                                        </div>
                                        <span className="font-medium">Debit Card</span>
                                    </div>
                                </div> */}

                                <div
                                    onClick={() => handlePaymentMethodSelect('credit_card')}
                                    className={`border rounded-lg p-4 cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50 ${formData.paymentMethod === 'credit_card' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                                >
                                    <div className="flex items-center space-x-3">
                                        <div className={`w-6 h-6 flex-shrink-0 rounded-full border ${formData.paymentMethod === 'credit_card' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center`}>
                                            {formData.paymentMethod === 'credit_card' && (
                                                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                                            )}
                                        </div>
                                        <span className="font-medium">Credit Card</span>
                                    </div>
                                </div>

                                {/* <div
                                    onClick={() => handlePaymentMethodSelect('upi')}
                                    className={`border rounded-lg p-4 cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50 ${formData.paymentMethod === 'upi' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                                >
                                    <div className="flex items-center space-x-3">
                                        <div className={`w-6 h-6 flex-shrink-0 rounded-full border ${formData.paymentMethod === 'upi' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center`}>
                                            {formData.paymentMethod === 'upi' && (
                                                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                                            )}
                                        </div>
                                        <span className="font-medium">UPI</span>
                                    </div>
                                </div> */}

                                {/* <div
                                    onClick={() => handlePaymentMethodSelect('NETBANKING')}
                                    className={`border rounded-lg p-4 cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50 ${formData.paymentMethod === 'NETBANKING' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                                >
                                    <div className="flex items-center space-x-3">
                                        <div className={`w-6 h-6 flex-shrink-0 rounded-full border ${formData.paymentMethod === 'NETBANKING' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center`}>
                                            {formData.paymentMethod === 'NETBANKING' && (
                                                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                                            )}
                                        </div>
                                        <span className="font-medium">Net Banking</span>
                                    </div>
                                </div> */}
                            </div>

                            {errors.paymentMethod && (
                                <p className="text-red-500 text-sm mb-4 error-message">{errors.paymentMethod}</p>
                            )}

                            <button
                                onClick={handlePaymentOptionsContinue}
                                className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-md font-medium"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showResponsePopup && customerApiResponse && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 relative">
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-center mb-4">Customer Registration</h2>

                            <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
                                {/* <div className="flex items-center mb-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="font-medium text-green-800">{customerApiResponse.status}</span>
                                </div> */}
                                <p className="text-green-700">{customerApiResponse.message}</p>
                                {customerApiResponse.txn_id && (
                                    <div className="mt-2 pt-2 border-t border-green-200">
                                        <p className="text-sm text-gray-600">Transaction ID: <span className="font-medium">{customerApiResponse.txn_id}</span></p>
                                    </div>
                                )}

                            </div>

                            <button
                                onClick={handleResponsePopupClose}
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-md font-medium"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showFeePopup && feeData && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 relative">
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-center mb-4">Transaction Fee Details</h2>

                            <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6">
                                <table className="w-full">
                                    <tbody>
                                        <tr className="border-b border-blue-100">
                                            <td className="py-2 text-gray-600">You pay:</td>
                                            <td className="py-2 text-right font-medium">₹{feeData.net_amount.toFixed(2)}</td>
                                        </tr>
                                        <tr className="border-b border-blue-100">
                                            <td className="py-2 text-gray-600">Transaction fee:</td>
                                            <td className="py-2 text-right font-medium">₹{feeData.fee.toFixed(2)}</td>
                                        </tr>
                                        {feeData.vat > 0 && (
                                            <tr className="border-b border-blue-100">
                                                <td className="py-2 text-gray-600">VAT:</td>
                                                <td className="py-2 text-right font-medium">₹{feeData.vat.toFixed(2)}</td>
                                            </tr>
                                        )}
                                        <tr className="border-t-2 border-blue-200">
                                            <td className="py-3 text-gray-800 font-medium">Recipient gets:</td>
                                            <td className="py-3 text-right font-bold text-lg">₹{feeData.txn_amount.toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {feeData.additional_note && (
                                    <p className="text-sm text-gray-600 mt-2">{feeData.additional_note}</p>
                                )}
                            </div>

                            <div className="flex space-x-4">
                                <button
                                    onClick={handleFeeConfirmation}
                                    disabled={loading}
                                    className={`w-1/2 py-3 rounded-md font-medium text-white transition 
    ${loading ? 'bg-green-300 cursor-not-allowed opacity-70' : 'bg-green-500 hover:bg-green-600 cursor-pointer'}`}
                                >
                                    {loading ? 'Processing...' : 'Proceed'}
                                </button>
                                <button
                                    onClick={handleFeeCancellation}
                                    className="w-1/2 border border-gray-300 hover:bg-gray-100 text-gray-600 py-3 rounded-md font-medium"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {notification.show && (
                <div
                    className={`fixed bottom-4 right-4 px-6 py-3 rounded-md shadow-lg text-white z-50 transition-opacity duration-300 ${notification.type === 'success' ? 'bg-green-500' :
                        notification.type === 'error' ? 'bg-red-500' :
                            notification.type === 'info' ? 'bg-blue-500' : 'bg-yellow-500'
                        }`}
                >
                    {notification.message}
                </div>
            )}
            {showErrorPopup && errorResponse && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 relative">
                        <div className="p-6">
                            <div className="flex items-center justify-center mb-4">
                                {/* Error Icon */}
                                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.732 0L4.362 15.5c-.77.833.192 2.5 1.732 2.5z" />
                                    </svg>
                                </div>
                            </div>

                            <h2 className="text-2xl font-bold text-center text-red-600 mb-4">Payment Initiation Failed</h2>

                            <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
                                <div className="space-y-2">
                                    {/* <div className="flex items-start">
                                        <span className="text-sm font-medium text-red-800 mr-2">Error:</span>
                                        <span className="text-sm text-red-700">{errorResponse.error || 'Unknown error'}</span>
                                    </div> */}
                                    <div className="flex items-start">
                                        <span className="text-sm font-medium text-red-800 mr-2">Message:</span>
                                        <span className="text-sm text-red-700">{errorResponse.message}</span>
                                    </div>
                                    {/* <div className="flex items-start">
                                        <span className="text-sm font-medium text-red-800 mr-2">Error Code:</span>
                                        <span className="text-sm text-red-700">{errorResponse.error_code}</span>
                                    </div>
                                    {errorResponse.status && (
                                        <div className="flex items-start">
                                            <span className="text-sm font-medium text-red-800 mr-2">Status:</span>
                                            <span className="text-sm text-red-700">{errorResponse.status}</span>
                                        </div>
                                    )} */}
                                    {errorResponse.timestamp && (
                                        <div className="flex items-start">
                                            <span className="text-sm font-medium text-red-800 mr-2">Timestamp:</span>
                                            <span className="text-sm text-red-700">{new Date(errorResponse.timestamp).toLocaleString()}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="text-center text-sm text-gray-600 mb-6">
                                Please try again or contact support if the problem persists.
                            </div>

                            <div className="flex space-x-4">
                                <button
                                    onClick={handleErrorPopupClose}
                                    className="w-1/2 bg-red-500 hover:bg-red-600 text-white py-3 rounded-md font-medium transition-colors"
                                >
                                    Close
                                </button>
                                <button
                                    onClick={() => {
                                        setShowErrorPopup(false);
                                        setErrorResponse(null);
                                        // Go back to payment options modal
                                        setShowPaymentOptionsModal(true);
                                    }}
                                    className="w-1/2 border border-gray-300 hover:bg-gray-100 text-gray-600 py-3 rounded-md font-medium transition-colors"
                                >
                                    Try Again
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
